import { provideHttpClient, withFetch } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideEffects } from '@ngrx/effects';
import { provideRouterStore } from '@ngrx/router-store';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { Silo } from '@org-quicko/silo-client';
import { RIVE_FOLDER } from 'ng-rive';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { CustomSerializer } from './serializers/custom-route.serializer';
import { RootReducers } from './store/app.model';
import { ReferenceDataEffects } from './store/reference-data/reference-data.effects';
import { AuthEffects } from './store/user/user.effects';


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideClientHydration(),
    provideAnimations(),
    provideStoreDevtools(),
    provideStore(RootReducers),
    provideEffects(AuthEffects, ReferenceDataEffects),
    provideRouterStore({
      serializer: CustomSerializer
    }),
    provideHttpClient(withFetch()),
    {
      provide: Silo,
      useValue: new Silo({
        url: environment.silo_url,
        cache: {
          enabled: true,
          ttl: 5 * 60 * 1000,
          maxSize: 5,
        },
      }),
    },
    {
      provide: RIVE_FOLDER,
      useValue: "/assets/animations"
    },
  ]
};
